import { render } from "./ClientArea.vue?vue&type=template&id=27b112e0&scoped=true"
import script from "./ClientArea.vue?vue&type=script&lang=js"
export * from "./ClientArea.vue?vue&type=script&lang=js"

import "./ClientArea.vue?vue&type=style&index=0&id=27b112e0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\weapon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b112e0"]])

export default __exports__